import { render, staticRenderFns } from "./WaitPay.vue?vue&type=template&id=1f9d33bd&scoped=true&"
import script from "./WaitPay.vue?vue&type=script&lang=js&"
export * from "./WaitPay.vue?vue&type=script&lang=js&"
import style0 from "./WaitPay.vue?vue&type=style&index=0&id=1f9d33bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9d33bd",
  null
  
)

export default component.exports